import React, {FC} from 'react';

import {useAppSelector} from 'store/config/hooks';
import {selectModalData, TModalComponentInterface} from 'store/slices/modals-slice';

import {FormEditModal} from './form-edit-modal';

interface IFormModalContainerProps extends TModalComponentInterface {
}

export const FormEditEntityComponent: FC<
    IFormModalContainerProps
> = ({
    onClose,
}: IFormModalContainerProps) => {
    const entityName = useAppSelector(state => selectModalData(state)?.entityName);
    const referenceUrl = useAppSelector(state => selectModalData(state)?.modalParameters?.referenceUrl);
    return (
        <FormEditModal
            entityName={entityName || ''}
            onClose={onClose}
            referenceUrl={referenceUrl}
            forceHasTitle
        />
    );
};
